import { AreasFilterType, StateModalStatus } from 'common/interfaces/state';
import { Search } from 'components/action';
import { Modal } from 'components/content';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppStore } from 'stores/AllStores';
import { StateRepsList } from './StateRepsList';
import {
    StateAreaList,
    StateList,
    StateRepAssignedAreas,
} from 'components/state';

// Styles
const s = require('./State.css');
const backArrow = require('assets/back icon.svg');

// Props
interface IStateProps {
    store?: IAppStore;
}

// Component
@inject('store')
@observer
export class State extends React.Component<IStateProps, {}> {
    public render() {
        // Destructure
        const { state } = this.props.store;

        // Render
        return (
            <Modal
                onModalClose={this.closeModal}
                closeModalOnBackgroundClick={false}
                show={state.modalStatus !== StateModalStatus.Closed}
                title={
                    state.modalStatus === StateModalStatus.OpenOnRepAreasList
                        ? 'Sales reps areas'
                        : state.modalStatus ===
                          StateModalStatus.OpenOnSpecificRepArea
                        ? 'Sales rep areas'
                        : 'Assign sales reps to leads'
                }
                titleBarContent={
                    state.modalStatus === StateModalStatus.OpenOnRepAreasList
                        ? this.renderRepsSearchBar()
                        : state.modalStatus ===
                          StateModalStatus.OpenOnSpecificArea
                        ? this.renderAreasBar()
                        : state.modalStatus ===
                          StateModalStatus.OpenOnStatesList
                        ? this.renderStatesSearchBar()
                        : null
                }
                titleBarIcons={
                    state.modalStatus === StateModalStatus.OpenOnRepAreasList
                        ? undefined
                        : [
                              {
                                  key: 'back-arrow',
                                  label:
                                      state.modalStatus ===
                                      StateModalStatus.OpenOnSpecificArea
                                          ? 'Back to states list'
                                          : 'Back',
                                  showLabel: true,
                                  icon: backArrow,
                                  className: s.backArrow,
                                  iconClassName: s.backArrowIcon,
                                  onClick: this.handleGoingBack,
                              },
                          ]
                }
            >
                <div className={s.state}>
                    {state.modalStatus ===
                    StateModalStatus.OpenOnRepAreasList ? (
                        <StateRepsList />
                    ) : state.modalStatus ===
                      StateModalStatus.OpenOnSpecificRepArea ? (
                        <StateRepAssignedAreas />
                    ) : state.modalStatus ===
                      StateModalStatus.OpenOnSpecificArea ? (
                        <StateAreaList />
                    ) : (
                        <StateList />
                    )}
                </div>
            </Modal>
        );
    }

    private renderRepsSearchBar = () => {
        return (
            <Search
                classNameForField={s.repsSearchField}
                onValueChange={this.handleRepsSearchChange}
                placeholder="Search sales reps by name..."
                value={this.props.store.state.repsSearch}
                isValueClearable={true}
            />
        );
    };

    @action
    private handleRepsSearchChange = (value: string) => {
        this.props.store.state.repsSearch = value;
    };

    private renderStatesSearchBar = () => {
        return (
            <Search
                classNameForField={s.statesSearchField}
                onValueChange={this.handleStateSearchChange}
                placeholder="Search state..."
                value={this.props.store.state.statesListSearch}
                isValueClearable={true}
            />
        );
    };

    private handleStateSearchChange = (value: string) => {
        this.props.store.state.statesListSearch = value;
    };

    private renderAreasBar = () => {
        const areasFilterTypeKeys = Object.keys(AreasFilterType);

        return (
            <select
                className={s.statesSearchBar}
                value={this.props.store.state.stateAreasSearch}
                onChange={this.handleStateAreasFilterChange}
            >
                {areasFilterTypeKeys.map((areaFilter, areaFilterIndex) => {
                    return (
                        <option
                            key={areaFilter}
                            value={AreasFilterType[areaFilter]}
                        >
                            {AreasFilterType[areaFilter]}
                        </option>
                    );
                })}
            </select>
        );
    };

    @action
    private handleStateAreasFilterChange = (
        e: React.ChangeEvent<HTMLSelectElement>
    ) => {
        this.props.store.state.stateAreasSearch = e.currentTarget
            .value as AreasFilterType;
    };

    @action
    private handleGoingBack = () => {
        const {
            state: { modalStatus },
        } = this.props.store;

        this.props.store.state.modalStatus =
            modalStatus === StateModalStatus.OpenOnSpecificArea
                ? StateModalStatus.OpenOnStatesList
                : StateModalStatus.OpenOnRepAreasList;
    };

    @action
    private closeModal = () => {
        this.props.store.state.modalStatus = StateModalStatus.Closed;
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/state/State.tsx